import React from "react";
import _ from "lodash";
import {
  Card,
  CardContent,
  Typography,
  Tooltip,
  Switch,
  FormControlLabel,
  Divider,
  makeStyles
} from "@material-ui/core";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import { useDispatch, useSelector } from "react-redux";
import { useStepThreeStyles, borderRadiusValue } from "../lib/constants";
import { addCheckedTags, removeAllCheckedTags } from "../epics/stepThreeEpics";

const useStyles = makeStyles(
  () => ({
    heading: {
      fontSize: "1.2rem"
    }
  }),
  { name: "TagCloudContainer" }
);

export default function TagCloudContainer(props) {
  const { children, needResize } = props;
  const resize = needResize[0] || needResize[1];
  const tagCloudClasses = useStyles();
  const classes = useStepThreeStyles({ sizeBreak: resize });
  const dispatch = useDispatch();
  const checkedCardStepOne = useSelector((state) => state.checkedCardStepOne);
  const checkedCardStepTwo = useSelector((state) => state.checkedCardStepTwo);
  const allKeyphrases = useSelector((state) => state.keyphrases);

  const tooltipText =
    "Wähle beliebig viele extrahierte Schlüsselwörter aus, um sie in der 3D-Ansicht anzusehen und einer Gruppe der bestehenden Unternehmenstaxonomie zuzuordnen und diese so zu erweitern.";
  const keyphrases = React.useMemo(
    () => _.map(allKeyphrases[checkedCardStepOne + " " + checkedCardStepTwo], (ignore, key) => key),
    [allKeyphrases, checkedCardStepOne, checkedCardStepTwo]
  );

  const [toggleAllChecked, setToggleAllChecked] = React.useState(true);

  const handleToggleAllChange = () => {
    const toggledState = !toggleAllChecked;
    const text = checkedCardStepOne + " " + checkedCardStepTwo;
    if (toggledState === true) {
      dispatch(addCheckedTags(text, keyphrases));
    } else {
      dispatch(removeAllCheckedTags(text));
    }
    setToggleAllChecked(toggledState);
  };

  return (
    <div className={classes.root}>
      <div className={classes.headerContainer}>
        <Typography className={tagCloudClasses.heading} variant="subtitle2">
          Extrahierte Schlüsselwörter
        </Typography>
        <Tooltip
          id="schluesselwort-erklaerung"
          title={tooltipText}
          placement="bottom-start"
          classes={{ tooltip: classes.popoverStyling }}
        >
          <InfoOutlinedIcon classes={{ root: classes.infoIconStyling }} />
        </Tooltip>
      </div>
      <Card
        style={{
          marginTop: "15px",
          borderRadius: borderRadiusValue
        }}
        classes={{ root: classes.paper }}
      >
        <div
          style={{
            height: "calc(100% - 40px)",
            overflow: "auto"
          }}
        >
          <CardContent classes={{ root: classes.fullHeight }}>{children}</CardContent>
        </div>
        <Divider />
        <div className={classes.toggleButtonContainer}>
          <FormControlLabel
            control={<Switch checked={toggleAllChecked} onChange={() => handleToggleAllChange()} color="primary" />}
            label={toggleAllChecked === true ? "Alle Schüsselwörter ausgewählt" : "Alle Schlüsselwörter abgewählt"}
          />
        </div>
      </Card>
    </div>
  );
}
